module.exports = __webpack_public_path__ + "static/media/emot1_off.9d288d4d.svg";